import React, {Component} from "react";
import Bets from "./Bets";
import {
	clearCoupon, getCoupon, makeBet, nextCoupon, prevCoupon, setGoldbet,
	setLiveOpt
} from "../../redux/actions/coupon";
import {connect} from "react-redux";
import LiveWidget from "../LiveWidget/LiveWidget";
import Loading from "../Loading";

class CouponLive extends Component {
	state = {
		sum                 : null,
		clearAfterBet       : true,
		acceptChangesOpened : false,
		processing          : false
	};

	changeSum(e) {
		const {couponStorage} = this.props;
		const {coupon} = couponStorage;

		let amount = e.target.value;
		if ( +e.target.value >= coupon.max ) {
			amount = coupon.max;
		}

		if ( e.target.value === '' ) {
			amount = null;
		}

		this.setState({
			sum : amount
		});
	}

	setSum(amount) {
		this.setState({
			sum : amount
		});
	}

	next() {
		this.props.onNextCoupon(this.props.type);
	}

	prev() {
		this.props.onPrevCoupon(this.props.type);
	}

	changeGoldBet(e) {
		this.props.onSetGoldbet(+e.target.checked, this.props.type);
	}

	changeClearAfterBet(e) {
		this.setState({
			clearAfterBet : !e.target.checked
		});
	}

	clearCoupon() {
		this.props.onClearCoupon(this.props.type);
		this.setState({
			sum : null
		});
	}

	acceptChangesToggle() {
		this.setState({
			acceptChangesOpened : !this.state.acceptChangesOpened
		});
	}

	changeLiveOpt(e) {
		this.props.onSetLiveopt(e.target.value);
	}

	makeBet() {
		const isMakeBet = !(this.state.sum === 0);

		if ( !isMakeBet ) {
			return false;
		}

		const {couponStorage} = this.props;
		if ( couponStorage.isEmpty ) {
			return false;
		}

		const {coupon} = couponStorage;

		this.setState({
			processing : true
		}, () => {
			this.props.onMakeBet(this.props.type, {
				amount : this.state.sum,
				clear  : +!this.state.clearAfterBet,
				gold   : parseInt(coupon.isGoldBet)
			});
		});
	}

	componentWillReceiveProps(nextProps) {
		const {couponStorage} = nextProps;
		const {coupon} = couponStorage;

		if ( !coupon || (couponStorage.coupon.position === 0 && couponStorage.isEmpty) ) {
			return null;
		}

		if ( couponStorage.hasOwnProperty('messages') ) {
			this.setState({
				processing : false
			});
		}
	}

	render() {
		const {couponStorage, oneclick} = this.props;
		const {coupon} = couponStorage;

		if ( oneclick.isOneClick || !coupon || (couponStorage.coupon.position === 0 && couponStorage.isEmpty) ) {
			return <LiveWidget/>;
		}

		const messages = couponStorage.hasOwnProperty('messages') ? couponStorage.messages : [];

		const hasBets = coupon.hasOwnProperty('bets');
		const couponPosition = coupon.position + 1;

		const acceptText = {
			1 : "никогда",
			2 : "при повышении",
			3 : "всегда"
		};

		return (
			// Купон
			<div className="coupon">
				<div className="coupon__header">
					<span className="coupon__header-title">Купон</span>
					<span className="coupon__number">
						{couponPosition > 1 &&
						<span className="coupon__number-left" onClick={this.prev.bind(this)}>
							<i className="fas fa-caret-left"></i>
						</span>}
						<span className="coupon__number-counter">{couponPosition}</span>
						{!coupon.isLast &&
						<span className="coupon__number-right" onClick={this.next.bind(this)}>
							<i className="fas fa-caret-right"></i>
						</span>}
					</span>
				</div>
				<div className="coupon__content">
					{this.state.processing &&
					<div className="coupon__content-processing animated fadeIn">
						<Loading/>
					</div>}

					{messages.length > 0 && <div className="coupon__content-messages">{messages}</div>}

					{hasBets && <Bets bets={coupon.bets}/>}

					{hasBets &&
					<div className="coupon__content__total">
						<div>
							<div>Общий коэффициент</div>
							<div><strong>{coupon.totalValue}</strong></div>
						</div>

						<div>
							<div>Сумма</div>
							<div><input type="text" onChange={this.changeSum.bind(this)} value={this.state.sum || ''}/>
							</div>
						</div>

						<div>
							<div>Возм. выигрыш</div>
							<div><strong>{(this.state.sum * coupon.totalValue).toFixed(2)}</strong></div>
						</div>

						<div>
							<div>Макс. ставка</div>
							<div>
								<span className="max-bet" onClick={this.setSum.bind(this, coupon.max)}>{coupon.max}</span>
							</div>
						</div>

						<div>
							<div>Goldbet</div>
							<div className="checkbox">
								<input type="checkbox"
								       id="coupon-goldbet"
								       onChange={this.changeGoldBet.bind(this)}
								       checked={coupon.isGoldBet}/>
								<label htmlFor="coupon-goldbet"></label>
							</div>
						</div>

						<div>
							<div className="buttons">
								<button className="buttons__show" onClick={this.makeBet.bind(this)}>Сделать ставку
								</button>
								<button className="buttons__clear" onClick={this.clearCoupon.bind(this)}>Очистить</button>
							</div>
						</div>
					</div>
					}

					<div className="coupon__content-save_select">
						<div className="checkbox">
							<input type="checkbox"
							       id="save_select"
							       onChange={this.changeClearAfterBet.bind(this)}
							       value={this.state.clearAfterBet}/>
							<label htmlFor="save_select">
								<div>Сохранить выборы в купоне после размещения ставки</div>
							</label>
						</div>
					</div>
					<div className="coupon__content-accept_changes" onClick={this.acceptChangesToggle.bind(this)}>
						<div>
							<i className={`fas fa-caret-${this.state.acceptChangesOpened ? 'up' : 'down'} coupon__content-accept_changes-toggle`}></i>
						</div>
						<div>Соглашаться с изменением — {acceptText[couponStorage.liveOpt]}</div>
					</div>

					{this.state.acceptChangesOpened &&
					<div className="coupon__content-accept_changes-data">
						<div>
							<input type="radio" id="ch-down" name="change-opt"
							       value={2}
							       checked={couponStorage.liveOpt === 2}
							       onChange={this.changeLiveOpt.bind(this)}/>
							<label htmlFor="ch-down">при повышении</label>
						</div>

						<div>
							<input type="radio" id="ch-accept" name="change-opt"
							       value={3}
							       checked={couponStorage.liveOpt === 3}
							       onChange={this.changeLiveOpt.bind(this)}/>
							<label htmlFor="ch-accept">всегда</label>
						</div>

						<div>
							<input type="radio" id="ch-notify" name="change-opt"
							       value={1}
							       checked={couponStorage.liveOpt === 1}
							       onChange={this.changeLiveOpt.bind(this)}/>
							<label htmlFor="ch-notify">никогда</label>
						</div>
					</div>}
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		oneclick      : state.oneclick,
		couponStorage : state.coupon
	}),
	dispatch => ({
		onNextCoupon  : (type) => {
			dispatch(nextCoupon(type));
		},
		onPrevCoupon  : (type) => {
			dispatch(prevCoupon(type));
		},
		onClearCoupon : (type) => {
			dispatch(clearCoupon(type));
		},
		onSetGoldbet  : (gold, type, system = 0) => {
			dispatch(setGoldbet(gold, type, system));
		},
		onSetLiveopt  : (option) => {
			dispatch(setLiveOpt(option));
		},
		onMakeBet     : (type, data) => {
			dispatch(makeBet(type, data));
		}
	})
)(CouponLive);


// WEBPACK FOOTER //
// ./src/app/components/Coupon/CouponLive.js